import React from "react";
import { FaLinkedin, FaWhatsapp } from "react-icons/fa";
import {  useLocation } from "react-router-dom";
import logo from "../assets/images/logo.png"; // Update this path to match your logo location

const Footer = () => {
  const location = useLocation();

  // Handle scroll to section for home page with proper offset
  const scrollToSection = (sectionId) => {
    if (location.pathname === "/") {
      // If already on home page, just scroll to section
      const element = document.getElementById(sectionId);
      if (element) {
        const navbarHeight = 120; // Adjust based on your navbar height
        const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - navbarHeight;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    } else {
      // If on different page, navigate to home and then scroll
      window.location.href = `/#${sectionId}`;
    }
  };

  return (
    <footer className="">
      <div className="mx-auto max-w-7xl px-4 lg:px-12 p-12 rounded-2xl">
        <div className="flex flex-col min-[830px]:flex-row items-center justify-between gap-6 pb-10 border-b-2 border-gray-700">
          {/* Logo */}
          <button onClick={() => scrollToSection("home")} className="flex items-center">
            <img
              src={logo}
              alt="Hack Defense Logo"
              className="h-8 w-auto md:h-10"
            />
          </button>

          {/* Navigation Links */}
          <ul className="flex flex-col sm:flex-row items-center gap-5 sm:gap-8">
            <li>
              <button
                onClick={() => scrollToSection("home")}
                className="text-lg font-normal text-gray-300 transition-all duration-300 hover:text-white focus-within:text-white focus-within:outline-0"
              >
                Home
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("about")}
                className="text-lg font-normal text-gray-300 transition-all duration-300 hover:text-white focus-within:text-white focus-within:outline-0 cursor-pointer"
              >
                About
              </button>
            </li>
            <li>
              <button
                onClick={() => scrollToSection("contact")}
                className="text-lg font-normal text-gray-300 transition-all duration-300 hover:text-white focus-within:text-white focus-within:outline-0 cursor-pointer"
              >
                Contact
              </button>
            </li>
          </ul>
        </div>

        {/* Contact Info and Social Links */}
        <div className="pt-7 flex flex-col min-[520px]:flex-row items-center justify-between gap-6">
          <ul className="flex items-center gap-9">
            {[
              {
                label: "Email",
                value: "contact@hackdefense.org",
                href: "mailto:contact@hackdefense.org",
              },
              // {
              //   label: "Phone",
              //   value: "+44 7937 54367",
              //   href: "tel:+44793754367",
              // },
            ].map(({ label, value, href }) => (
              <li key={label}>
                <a
                  href={href}
                  className="text-sm font-normal text-gray-400 transition-all duration-300 hover:text-white focus-within:text-white focus-within:outline-0"
                >
                  {value}
                </a>
              </li>
            ))}
          </ul>

          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/hack-defense/"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-gray-600 p-2 rounded-full aspect-square text-gray-400 transition-all duration-500 hover:text-white hover:border-white focus-within:outline-0 focus-within:text-white focus-within:border-white"
            >
              <FaLinkedin size={20} />
            </a>
{/* 
            <a
              href="https://wa.me/44793754367"
              target="_blank"
              rel="noopener noreferrer"
              className="border border-gray-600 p-2 rounded-full aspect-square text-gray-400 transition-all duration-500 hover:text-white hover:border-white focus-within:outline-0 focus-within:text-white focus-within:border-white"
            >
              <FaWhatsapp size={20} />
            </a> */}
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-6 text-center">
          <p className="text-sm text-gray-400">
            © {new Date().getFullYear()} Hack Defense. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;